import { store } from '@/store/store'
import { ShipmentsStoreState } from '@/modules/shipments-module/store/shipments-store.model'

export class ShipmentsStoreHelper {
    /// SIDEBAR

    static get sidebarSelectedOption(): ShipmentsStoreState['selectedOption'] {
        return store.getters['shipments/selectedOption']
    }
    static get sidebarSelectedParentOption(): any {
        return store.getters['shipments/selectedParentOption']
    }

    static get summaries(): ShipmentsStoreState['summaries'] {
        return store.getters['shipments/summaries']
    }
    static set summaries(summaries: ShipmentsStoreState['summaries']) {
        store.commit('shipments/updateSummaries', summaries)
    }

    // actions
    static async setSidebarSelectedOption(selectedOption: ShipmentsStoreState['selectedOption']): Promise<void> {
        await store.dispatch('shipments/setSelectedOption', selectedOption)
    }

    /// GRID

    static get gridType(): ShipmentsStoreState['gridType'] {
        return store.getters['shipments/gridType']
    }

    static get filterModel(): ShipmentsStoreState['filterModel'] {
        return store.getters['shipments/filterModel']
    }
    static set filterModel(filterModel: ShipmentsStoreState['filterModel']) {
        store.commit('shipments/updateFilterModel', filterModel)
    }
}
